export default __webpack_public_path__ + "static/media/index.d.009f1182.ts";